module.exports = {"title":"David Blurton","talk":"Full stack JavaScript development with Docker","path":"/speakers/david-blurton","type":"speaker","slug":"david-blurton","twitter":"davidblurton","github":"davidblurton","website":"http://davidblurton.com/","companyWebsite":"http://takumi.com/","company":"Takumi","body":"<p>TBA</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./speakers/david-blurton.md
 ** module id = 494
 ** module chunks = 0
 **/